import React from "react";
import { Anchor, Group } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons";
import { useTabNavigate } from "../../hooks/useTabNavigate";

const MigrationBackLink = () => {
  const tabNav = useTabNavigate();

  return (
    <Group>
      <Anchor
        size="sm"
        onClick={() => tabNav.open({ pathname: "/management/dataMigration" })}
        sx={{ display: "inline-flex", alignItems: "center", gap: 4 }}
      >
        <IconArrowLeft size={14} />
        Back to sources
      </Anchor>
    </Group>
  );
};

export default MigrationBackLink;
